import {
  storeTokens as storeTokensSdk,
  getTokens as getTokensSdk,
  getIdToken as getIdTokenSdk,
  isAuthenticated as isAuthenticatedSdk,
  clearTokens as clearTokensSdk,
} from "@vault/cognito-auth";

// @vault/cognito-auth defaults to sessionStorage, which is per-tab. Opening a
// link with target="_blank" boots the SPA in a fresh tab with no tokens and
// bounces the user to /login. localStorage is shared across same-origin tabs
// and survives reloads, so we route every token operation through here.
const opts = { storage: localStorage };

export const storeTokens = (tokens) => storeTokensSdk(tokens, opts);
export const getTokens = () => getTokensSdk(opts);
export const getIdToken = () => getIdTokenSdk(opts);
export const isAuthenticated = () => isAuthenticatedSdk(opts);
export const clearTokens = () => clearTokensSdk(opts);
